import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/:staffPaymentId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/:staffPaymentId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/:staffPaymentId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/:staffPaymentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/:staffPaymentId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS].DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_payments/:staffPaymentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}